import { CANADA_ISO, US_ISO } from "./country";

const usaStates = [
  { id: 1, name: "Michigan", abbr: "MI" },
  { id: 11, name: "South Dakota", abbr: "SD" },
  { id: 21, name: "Washington", abbr: "WA" },
  { id: 31, name: "Wisconsin", abbr: "WI" },
  { id: 41, name: "Arizona", abbr: "AZ" },
  { id: 51, name: "Illinois", abbr: "IL" },
  { id: 61, name: "New Hampshire", abbr: "NH" },
  { id: 71, name: "North Carolina", abbr: "NC" },
  { id: 81, name: "Kansas", abbr: "KS" },
  { id: 91, name: "Missouri", abbr: "MO" },
  { id: 101, name: "Arkansas", abbr: "AR" },
  { id: 111, name: "Nevada", abbr: "NV" },
  { id: 121, name: "District of Columbia", abbr: "DC" },
  { id: 131, name: "Idaho", abbr: "ID" },
  { id: 141, name: "Nebraska", abbr: "NE" },
  { id: 151, name: "Pennsylvania", abbr: "PA" },
  { id: 161, name: "Hawaii", abbr: "HI" },
  { id: 171, name: "Utah", abbr: "UT" },
  { id: 181, name: "Vermont", abbr: "VT" },
  { id: 191, name: "Delaware", abbr: "DE" },
  { id: 201, name: "Rhode Island", abbr: "RI" },
  { id: 211, name: "Oklahoma", abbr: "OK" },
  { id: 221, name: "Louisiana", abbr: "LA" },
  { id: 231, name: "Montana", abbr: "MT" },
  { id: 241, name: "Tennessee", abbr: "TN" },
  { id: 251, name: "Maryland", abbr: "MD" },
  { id: 261, name: "Florida", abbr: "FL" },
  { id: 271, name: "Virginia", abbr: "VA" },
  { id: 281, name: "Minnesota", abbr: "MN" },
  { id: 291, name: "New Jersey", abbr: "NJ" },
  { id: 301, name: "Ohio", abbr: "OH" },
  { id: 311, name: "California", abbr: "CA" },
  { id: 321, name: "North Dakota", abbr: "ND" },
  { id: 331, name: "Maine", abbr: "ME" },
  { id: 341, name: "Indiana", abbr: "IN" },
  { id: 351, name: "Texas", abbr: "TX" },
  { id: 361, name: "Oregon", abbr: "OR" },
  { id: 371, name: "Wyoming", abbr: "WY" },
  { id: 381, name: "Alabama", abbr: "AL" },
  { id: 391, name: "Iowa", abbr: "IA" },
  { id: 401, name: "Mississippi", abbr: "MS" },
  { id: 411, name: "Kentucky", abbr: "KY" },
  { id: 421, name: "New Mexico", abbr: "NM" },
  { id: 431, name: "Georgia", abbr: "GA" },
  { id: 441, name: "Colorado", abbr: "CO" },
  { id: 451, name: "Massachusetts", abbr: "MA" },
  { id: 461, name: "Connecticut", abbr: "CT" },
  { id: 471, name: "New York", abbr: "NY" },
  { id: 481, name: "South Carolina", abbr: "SC" },
  { id: 491, name: "Alaska", abbr: "AK" },
  { id: 501, name: "West Virginia", abbr: "WV" },
  { id: 511, name: "U.S. Armed Forces - Americas", abbr: "AA" },
  { id: 521, name: "U.S. Armed Forces - Europe", abbr: "AE" },
  { id: 531, name: "U.S. Armed Forces - Pacific", abbr: "AP" },
  { id: 532, name: "Puerto Rico", abbr: "PR" },
];

const canadianStates = [
  { id: 295, name: "Alberta", abbr: "AB" },
  { id: 296, name: "British Columbia", abbr: "BC" },
  { id: 297, name: "Manitoba", abbr: "MB" },
  { id: 298, name: "New Brunswick", abbr: "NB" },
  { id: 299, name: "Newfoundland and Labrador", abbr: "NL" },
  { id: 300, name: "Nova Scotia", abbr: "NS" },
  { id: 301, name: "Northwest Territories", abbr: "NT" },
  { id: 302, name: "Nunavut", abbr: "NU" },
  { id: 303, name: "Ontario", abbr: "ON" },
  { id: 304, name: "Prince Edward Island", abbr: "PE" },
  { id: 305, name: "Quebec", abbr: "QC" },
  { id: 306, name: "Saskatchewan", abbr: "SK" },
  { id: 307, name: "Yukon Territory", abbr: "YT" },
];

export default {
  [US_ISO]: usaStates,
  [CANADA_ISO]: canadianStates,
};
